import { render } from "./Cookie.vue?vue&type=template&id=d3016ce8&scoped=true"
import script from "./Cookie.vue?vue&type=script&lang=js"
export * from "./Cookie.vue?vue&type=script&lang=js"

import "./Cookie.vue?vue&type=style&index=0&id=d3016ce8&scoped=true&lang=css"
import "./Cookie.vue?vue&type=style&index=1&id=d3016ce8&lang=css"

import exportComponent from "/home/denis/Projects/tavria/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3016ce8"]])

export default __exports__